import styled from 'styled-components';

const StyledSearchContainer = styled.div<{ $active: boolean }>`
	position: relative;
	height: 50px;
	background-color: ${({ $active }) =>
		$active ? '#ffffff' : 'rgba(255,255,255,0.1)'};
	transition: background-color 0.3s ease;
	border-radius: 10px;
`;

const StyledIcon = styled.img`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	z-index: 20;
	width: 24px;
	height: 24px;
	padding: 5px;
	opacity: 0.25;
	user-select: none;
	transform-origin: center;
	pointer-events: none;

	transition:
		opacity 0.3s ease,
		filter 0.3s ease;

	&:hover {
		opacity: 1;
	}
`;

const StyledSearchInput = styled.input.attrs({ type: 'text' })`
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	background-color: transparent;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	color: #ffffff;
	padding: 0 54px 0 20px;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
		user-select: none;
	}

	&:hover,
	&:focus {
		color: black;

		&::placeholder {
			color: rgba(0, 0, 0, 0.25);
		}

		& + ${StyledIcon} {
			filter: invert(100%);
			opacity: 1;
		}
	}

	transition: color 0.3s ease;
`;

export { StyledIcon, StyledSearchContainer, StyledSearchInput };
